export default class TrailPathConfig {
    private _sharpness: number;
    private _minDelta: number;
    private _maxTimeBetweenPointsInMilliseconds: number;

    constructor(sharpness: number = 0.1, minDelta: number = 0.05, maxTimeBetweenPointsInMilliseconds: number = 200) {
        this._sharpness = sharpness;
        this._minDelta = minDelta;
        this._maxTimeBetweenPointsInMilliseconds = maxTimeBetweenPointsInMilliseconds;
    }

    public get sharpness(): number {
        return this._sharpness;
    }

    public set sharpness(value: number) {
        this._sharpness = value;
    }

    public get minDelta(): number {
        return this._minDelta;
    }

    public set minDelta(value: number) {
        this._minDelta = value;
    }

    public get maxTimeBetweenPointsInMilliseconds(): number {
        return this._maxTimeBetweenPointsInMilliseconds;
    }

    public set maxTimeBetweenPointsInMilliseconds(value: number) {
        this._maxTimeBetweenPointsInMilliseconds = value;
    }
}